//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

// All names used in createSlice() calls must be unique across our redux store.
// Track them here.
export enum SliceNames {
  AccountSettingsAccount = 'ACCOUNT_SETTINGS/ACCOUNT',
  AccountSettingsAnalyticsProviders = 'ACCOUNT_SETTINGS/ANALYTICS_PROVIDERS',
  AccountSettingsEmailReports = 'ACCOUNT_SETTINGS/EMAIL_REPORTS',
  AccountSettingsPinterest = 'ACCOUNT_SETTINGS/PINTEREST',
  AccountSettingsTikTok = 'ACCOUNT_SETTINGS/TIKTOK',
  AccountSettingsTrackingParams = 'ACCOUNT_SETTINGS/TRACKING_PARAMS',
  AccountSettingsRightsManagement = 'ACCOUNT_SETTINGS/RIGHTS_MANAGEMENT',
  CampaignDetails = 'CAMPAIGNS/CAMPAIGN_DETAILS',
  CampaignsLists = 'CAMPAIGNS/CAMPAIGNS_LISTS',
  creatorsCampaignMembers = 'CREATORS_CAMPAIGN/CREATORS',
  CreatorsCampaignPaymentMembers = 'CREATORS_CAMPAIGN/PAYMENT_CREATORS',

  BeautifyModal = 'BEAUTIFY_MODAL',

  FacebookPages = 'FACEBOOK_PAGES',

  GalleriesConfigureRightsModal = 'GALLERIES_CONFIGURE_RIGHTS_MODAL',
  GalleriesData = 'GALLERIES_DATA',
  GalleriesAutoApprovalModal = 'GALLERIES_AUTO_APPROVAL_MODAL',

  InsightsGalleries = 'INSIGHTS/GALLERIES',
  InsightsLike2Buy = 'INSIGHTS/LIKE2BUY',
  InsightsLike2BuySummary = 'INSIGHTS/LIKE2BUY_SUMMARY',
  InsightsLike2BuyV2 = 'INSIGHTS/LIKE2BUY_V2',
  InsightsMetadata = 'INSIGHTS_METADATA',
  InsightsReveal = 'INSIGHTS/REVEAL',
  InsightsShowroom = 'INSIGHTS/SHOWROOM',
  InsightsSummary = 'INSIGHTS/SUMMARY',

  InstagramAccount = 'INSTAGRAM_ACCOUNT',
  InstagramAccountAudience = 'INSTAGRAM_ACCOUNT_AUDIENCE',
  InstagramAccountReelsPostDetails = 'INSTAGRAM_ACCOUNT_REELS_POST_DETAILS',
  InstagramAccountSchedule = 'INSTAGRAM_ACCOUNT_SCHEDULE',
  InstagramAccountScheduleExport = 'INSTAGRAM_ACCOUNT_SCHEDULE/EXPORT',
  InstagramAccountScheduleFeedPreview = 'INSTAGRAM_ACCOUNT_SCHEDULE/FEED_PREVIEW',
  InstagramAccountScheduleModals = 'INSTAGRAM_ACCOUNT_SCHEDULE/MODALS',
  InstagramAccountStoryGroupsEnagagement = 'INSTAGRAM_ACCOUNT_STORY_GROUPS_ENGAGEMENT',
  InstagramAccountStoryGroupsPostDetails = 'INSTAGRAM_ACCOUNT_STORY_GROUPS_POST_DETAILS',
  InstagramCompetitors = 'INSTAGRAM_COMPETITORS',
  InstagramHashtagInsights = 'INSTAGRAM_HASHTAG_INSIGHTS',
  InstagramHashtagPage = 'INSTAGRAM_HASHTAG_PAGE',
  InstagramHashtagRecentContent = 'INSTAGRAM_HASHTAG_RECENT_CONTENT',
  InstagramMentionedAndTagged = 'INSTAGRAM_MENTIONED_AND_TAGGED',
  InstagramShops = 'INSTAGRAM_SHOPS',
  InstagramShopsFeatureUgc = 'INSTAGRAM_SHOPS_FEATURE_UGC',
  InstagramShopsProductSearchModal = 'INSTAGRAM_SHOPS_PRODUCT_SEARCH_MODAL',
  InstagramSummary = 'INSTAGRAM_SUMMARY',

  Like2BuyModeration = 'LIKE_2_BUY_MODERATION',
  Like2BuyModerationModals = 'LIKE_2_BUY_MODERATION/MODALS',

  AllLabelsModal = 'ALL_LABELS_MODAL',
  ManageLabelsModal = 'MANAGE_LABELS_MODAL',

  MediaUploadQueue = 'MEDIA_UPLOAD_QUEUE',

  PinterestAudience = 'PINTEREST_AUDIENCE',
  PinterestEngagement = 'PINTEREST_ENGAGEMENT',
  PinterestPostDetails = 'PINTEREST_POST_DETAILS',
  PinterestPostDetailsModals = 'PINTEREST_POST_DETAILS/MODALS',
  PinterestSchedule = 'PINTEREST_SCHEDULE',
  PinterestScheduleModals = 'PINTEREST_SCHEDULE/MODALS',
  PinterestSummary = 'PINTEREST_SUMMARY',
  PinterestUser = 'PINTEREST_USER',

  ScheduleMedia = 'SCHEDULE_MEDIA',

  SocialResponseAllCommentsView = 'SOCIAL_RESPONSE/ALL_COMMENTS_VIEW',
  SocialResponsePostDetails = 'SOCIAL_RESPONSE/POST_DETAILS',
  SocialResponseMessageDetails = 'SOCIAL_RESPONSE/MESSAGE_DETAILS',

  StreamDelete = 'STREAM_DELETE',

  SyndicationInsights = 'BAZAARVOICE_SYNDICATION_INSIGHTS',

  TikTokAudience = 'TIKTOK_AUDIENCE',
  TikTokEngagement = 'TIKTOK_ENGAGEMENT',
  TikTokLike2Buy = 'TIKTOK_LIKE2BUY',
  TikTokLike2BuyCustomizations = 'TIKTOK_LIKE2BUY/CUSTOMIZATIONS',
  TikTokLike2BuyModerationModals = 'TIKTOK_LIKE2BUY/MODALS',
  TikTokSummary = 'TIKTOK_SUMMARY',
  TikTokVideoAutomaticPostDetails = 'TIKTOK_VIDEO_AUTOMATIC_POST_DETAILS',
  TikTokUser = 'TIKTOK_USER',

  TwitterAudience = 'TWITTER_AUDIENCE',
  TwitterEngagement = 'TWITTER_ENGAGEMENT',
  TwitterSchedule = 'TWITTER_SCHEDULE',
  TwitterScheduleModals = 'TWITTER_SCHEDULE/MODALS',
  TwitterSettings = 'TWITTER_SETTINGS',
  TwitterSummary = 'TWITTER_SUMMARY',
  TwitterUser = 'TWITTER_USER',

  UIAModalApproveForGalleries = 'UNIVERSAL_IMAGE_ACTIONS_MODAL_APPROVE_FOR_GALLERIES',
  UIAModal = 'UNIVERSAL_IMAGE_ACTIONS_MODAL',

  UniversalCalendar = 'UNIVERSAL_CALENDAR',
  UniversalDrafts = 'UNIVERSAL_DRAFTS',
}
